import { ApiErrorResponse } from '@/api/type/commonTypes';
import { PutPartnerBusinessProfileRequest } from '../type/types';
import { api } from '../axiosInstance';

export const putPartnerBusinessProfile = async (
  data: PutPartnerBusinessProfileRequest
) => {
  const res = await api.put<ApiErrorResponse>(
    '/api/web/partners/profile',
    data
  );
  return res.data;
};
